export enum Breakpoints {
    VERY_SMALL = '(max-width: 700px)',
    SMALL = '(max-width: 1024px)',
    MEDIUM = '(max-width: 1200px)',
}
